import React, { useState } from "react";
import "./DeleteAccountPopup.css";

const DeleteAccountPopup = ({ show, onCancel, onDelete }) => {
    const [confirmationText, setConfirmationText] = useState("");
    const requiredText = "Yes delete my account";
    const isDeleteEnabled = confirmationText === requiredText;

    const handleDelete = () => {
        if (isDeleteEnabled) {
            onDelete();
        }
    };

    if (!show) return null;

    return (
        <div className="delete-account-overlay">
            <div className="delete-account-popup">
                <h3>Delete Account</h3>
                <p className="warning-text">
                    Are you sure you want to delete your account? This action cannot be undone and will permanently remove all your data, including your collection, profile, and account information.
                </p>
                
                <div className="confirmation-input-section">
                    <label htmlFor="confirmation-input">
                        To confirm deletion, please type: <strong>"{requiredText}"</strong>
                    </label>
                    <input
                        id="confirmation-input"
                        type="text"
                        value={confirmationText}
                        onChange={(e) => setConfirmationText(e.target.value)}
                        placeholder="Type the confirmation text above"
                        className="confirmation-input"
                    />
                </div>

                <div className="delete-account-buttons">
                    <button 
                        onClick={onCancel} 
                        className="cancel-btn"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={handleDelete} 
                        className={`delete-btn ${!isDeleteEnabled ? 'disabled' : ''}`}
                        disabled={!isDeleteEnabled}
                    >
                        Delete Account
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteAccountPopup;
